<template>
  <div v-if="streak" class="streak-widget" @click="openModal">
    <div class="streak-icon-wrapper">
      <div class="fire-icon">🔥</div>
    </div>
    <div class="streak-content">
      <div class="streak-days">
        <span class="count">{{ streak.currentDay }}</span>
      </div>
      <div v-if="streak.canClaim" class="claim-indicator">
        Claim!
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProfileStore } from '@/store/profile'
import { useAppStore } from '@/store/app'

const profileStore = useProfileStore()
const appStore = useAppStore()

const streak = computed(() => profileStore.depositStreak)

function openModal() {
  appStore.setShowDepositStreakModal(true)
}
</script>

<style scoped lang="scss">
.streak-widget {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #1a1b2e; // Dark background
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-left: none; // No left border since it touches edge
  border-radius: 0 12px 12px 0; // Rounded on right side
  padding: 8px 12px; // Reduced padding
  cursor: pointer;
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 8px; // Reduced gap
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.4); // Shadow to right
  transition: all 0.3s ease;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, #ff9045, #ff5e3a);
  }

  &:hover {
    transform: translateY(-50%) translateX(5px); // Move out slightly to right
    background: #1f2137;
  }
}

.streak-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; // Smaller icon wrapper
  height: 32px;
  background: rgba(255, 144, 69, 0.1);
  border-radius: 50%;
  border: 1px solid rgba(255, 144, 69, 0.2);

  .fire-icon {
    font-size: 16px; // Smaller icon
    filter: drop-shadow(0 0 5px #ff5e3a);
    animation: flamePulse 2s infinite ease-in-out;
  }
}

.streak-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.streak-days {
  display: flex;
  align-items: center;

  .count {
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    font-family: 'Inter', sans-serif;
    line-height: 1;
  }
}

.claim-indicator {
  font-size: 9px; // Smaller
  color: #4ade80;
  font-weight: 700;
  margin-top: 2px;
  text-transform: uppercase;
  animation: bounce 1s infinite alternate;
}

@keyframes flamePulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes bounce {
  from { transform: translateY(0); }
  to { transform: translateY(-2px); }
}

@media (max-width: 768px) {
  .streak-widget {
    top: auto;
    bottom: 80px;
    left: 10px;
    right: auto;
    transform: none;
    border-radius: 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.05);
    
    &:hover {
      transform: translateY(-5px);
    }
  }
}
</style>
